import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('camp');
    const lists: any[] = [
        {
            img: '/responsive/picture/camp/3_1.jpg',
            title: t('secC_list1_title'),
            desc: t('secC_list1_desc'),
        },
        {
            img: '/responsive/picture/camp/3_2.jpg',
            title: t('secC_list2_title'),
            desc: t('secC_list2_desc'),
        },
        {
            img: '/responsive/picture/camp/3_3.jpg',
            title: t('secC_list3_title'),
            desc: t('secC_list3_desc'),
        },
        {
            img: '/responsive/picture/camp/3_4.jpg',
            title: t('secC_list4_title'),
            desc: t('secC_list4_desc'),
        },
        {
            img: '/responsive/picture/camp/3_5.jpg',
            title: t('secC_list5_title'),
            desc: t('secC_list5_desc'),
        },
    ];
    return (
        <div id="camp-C" className={`camp-C camp-box ${css['camp-C']}`}>
            <h2 className="title">{t('secC_title')}</h2>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/camp/3.jpg'} alt={t('secC_title')} />
            </div>
            <p className="desc">{t('secC_desc')}</p>
            <ul className="lists">
                {lists?.map((list: any, k: number) => (
                    <li className="list" key={k}>
                        <h3 className="list-title">{list?.title}</h3>
                        <div className="list-info">
                            <div className="list-img">
                                <EFPicture src={list?.img} alt={list?.title} />
                            </div>
                            <p className="list-desc desc">{list?.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
            <p className="desc tip">
                {t.rich('secC_text', {
                    a: (a: string) => (
                        <Link className="a-link" href={t('secC_text_link')}>
                            {a}
                        </Link>
                    ),
                })}
            </p>
        </div>
    );
}
